import { IRootState } from '..';

export const SELECTOR_UI_SETTINGS_VISIBLE = (state: IRootState) => state.UI.settingsVisible;
export const SELECTOR_UI_FULLSCREEN = (state: IRootState) => state.UI.fullscreen;
export const SELECTOR_UI_IS_USER_ACTIVE = (state: IRootState) => state.UI.isUserActive;
export const SELECTOR_UI_IS_PICTURE_IN_PICTURE_ENABLED = (state: IRootState) => state.UI.isPictureInPictureEnabled;
export const SELECTOR_UI_IS_MOUSE_ON_PLAYER = (state: IRootState) => state.UI.isMouseOnPlayer;
